require("core-js/modules/es6.array.for-each");

var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.array.map");

var Vertex3 = require('../core/math/Vertex3');

var Vector3 = require('../core/math/Vector3');

var Polygon3 = require('../core/math/Polygon3'); // FIXME: this is to have more readable/less extremely verbose code below


var vertexFromVectorArray = function vertexFromVectorArray(array) {
  return new Vertex3(new Vector3(array));
};

var polygonFromPoints = function polygonFromPoints(points) {
  // EEK talk about wrapping wrappers !
  var vertices = points.map(function (point) {
    return new Vertex3(new Vector3(point));
  });
  return new Polygon3(vertices);
}; // Simplified, array vector rightMultiply1x3Vector


var rightMultiply1x3VectorToArray = function rightMultiply1x3VectorToArray(matrix, vector) {
  var _vector = _slicedToArray(vector, 3),
      v0 = _vector[0],
      v1 = _vector[1],
      v2 = _vector[2];

  var v3 = 1;
  var x = v0 * matrix.elements[0] + v1 * matrix.elements[1] + v2 * matrix.elements[2] + v3 * matrix.elements[3];
  var y = v0 * matrix.elements[4] + v1 * matrix.elements[5] + v2 * matrix.elements[6] + v3 * matrix.elements[7];
  var z = v0 * matrix.elements[8] + v1 * matrix.elements[9] + v2 * matrix.elements[10] + v3 * matrix.elements[11];
  var w = v0 * matrix.elements[12] + v1 * matrix.elements[13] + v2 * matrix.elements[14] + v3 * matrix.elements[15]; // scale such that fourth element becomes 1:

  if (w !== 1) {
    var invw = 1.0 / w;
    x *= invw;
    y *= invw;
    z *= invw;
  }

  return [x, y, z];
};

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

var cagToPointsArray = function cagToPointsArray(input) {
  var points;

  if ('sides' in input) {
    // this is a cag
    points = [];
    input.sides.forEach(function (side) {
      points.push([side.vertex0.pos.x, side.vertex0.pos.y]);
      points.push([side.vertex1.pos.x, side.vertex1.pos.y]);
    }); // cag.sides.map(side => [side.vertex0.pos.x, side.vertex0.pos.y])
    //, side.vertex1.pos.x, side.vertex1.pos.y])
    // due to the logic of CAG.fromPoints()
    // move the first point to the last

    /* if (points.length > 0) {
      points.push(points.shift())
    } */
  } else if ('points' in input) {
    points = input.points.map(function (p) {
      return [p.x, p.y];
    });
  }

  return points;
};

var degToRad = function degToRad(deg) {
  return Math.PI / 180 * deg;
};

module.exports = {
  cagToPointsArray: cagToPointsArray,
  clamp: clamp,
  rightMultiply1x3VectorToArray: rightMultiply1x3VectorToArray,
  polygonFromPoints: polygonFromPoints
};